import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * Ana sayfa / projeler listesi kartı. `item` alanları `mapCmsProjectToCardItem`
 * (`src/api/cmsProjects.js`) ile CMS yanıtından üretilir.
 * @param {{ item: { id: string, imageUrl: string, title: string, description: string, href: string } }} props
 */
export function ProjectCard({ item }) {
    const { t } = useTranslation();
    return (
        <article className="project-card w-100 h-100 rounded-4 overflow-hidden">
            <div className="project-card-inner position-relative h-100">
                <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="project-card-image"
                    loading="lazy"
                />
                <div className="project-card-gradient" aria-hidden />
                <div className="project-card-content position-absolute bottom-0 start-0 end-0 p-4 text-start">
                    <h3 className="project-card-title text-white h5 mb-2 mb-md-3">
                        {item.title}
                    </h3>
                    <p className="project-card-desc text-white small mb-3 mb-md-4">
                        {item.description}
                    </p>
                    <Link
                        to={item.href}
                        className="project-card-cta d-inline-block text-decoration-none text-white small fw-semibold"
                    >
                        {t('home.projects.cardCta')}
                    </Link>
                </div>
            </div>
        </article>
    );
}
